import { styled } from 'solid-styled-components';
import theme from '../../../../style/theme';

export const StyledPostItem = styled.div<{ disabled?: boolean }>`
    background-color: ${p => p.disabled ? '#F7F7F7' : theme.palette.white};
    border-radius: ${theme.borderRadius.small};
    padding: ${theme.spacing.xs};
    margin-bottom: ${theme.spacing.xs};
    cursor: move;
    &:last-child {
        margin-bottom: 2rem;
    }
`;

export const StyledRemoveButton = styled.div`
    display: flex;
`;

export const StyledTextContainer = styled.div`
    padding-right: 1.5rem;
`;

export const StyledPostNotFoundExplainer = styled.div`
    background-color: #fff;
    padding: 0.75rem 1rem;
    border-radius: 1.07rem;
    margin-top: 2rem;
    margin-bottom: 0.75rem;
`;